import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, className, ...rest }, ref) => {
    const generated = `input-${Math.random().toString(36).slice(2, 8)}`;
    const inputId = id ?? generated;
    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={inputId} className="label">
            {label}
          </label>
        )}
        <input
          id={inputId}
          ref={ref}
          className={cn('input', error && 'border-brand-error', className)}
          {...rest}
        />
        {error && <p className="text-xs text-brand-error">{error}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';
